import React, { memo } from 'react'

import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import LogoMark from 'images/cg_icon_rgb_small.svg'
import LogoWordmark from 'images/cgtrader_RGB.svg'

function Logo({ url, locale = 'en' }) {
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  return (
    <a
      className="unified-nav__logo"
      data-track-text=""
      data-track-label="Homepage"
      href={url}
    >
      <picture>
        <source media="(min-width: 460px)" srcSet={LogoWordmark} />
        <img
          className="unified-nav__logo-img"
          src={LogoMark}
          alt={t('navigation.aria.logo')}
          width="106"
          height="24"
        />
      </picture>
    </a>
  )
}

Logo.propTypes = {
  url: string.isRequired,
  locale: string,
}

export default memo(Logo)
